import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FirebaseService } from '../services/firebase.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private firebaseService: FirebaseService,private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
      let errors = params[':error'];
      this.error = errors;
      let successs = params[':success'];
      this.success = successs;
    });
  }
  error!:string;
  success!:string;

  public loginForm = new FormGroup({
    email: new FormControl('',  Validators.required),
    password: new FormControl('',  Validators.required),

  });

  login(formData: FormData){
    this.firebaseService.login(formData["email"], formData["password"]);
  }
  forgot_password(email: string){
    if(!email){
window.alert("Please enter email id");
    }else{
    this.firebaseService.forgotpassword(email);
  }
  }
  ngOnInit() {
  }

}
